import React from 'react';
import './Music.css';

const STREAMING_LINKS = [
  {
    label: 'Spotify',
    href: 'https://open.spotify.com/artist/63z9YSnIfEs8ycriPWBWOU?si=Dg4xzSAnTaKvxPFYbsdK7w',
    color: '#1DB954',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
      </svg>
    ),
  },
  {
    label: 'Apple Music',
    href: 'https://music.apple.com/us/artist/echo-hill/1882167530',
    color: '#fc3c44',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.064-2.31-2.22-3.01a5.622 5.622 0 00-1.89-.737c-.55-.13-1.11-.2-1.67-.21-.03-.01-.12-.01-.15-.01H5.864c-.06 0-.12.01-.18.01-.75.04-1.49.18-2.19.48C2.39 1.04 1.55 1.78.94 2.76a5.48 5.48 0 00-.69 1.83c-.12.56-.18 1.13-.19 1.71-.01.06-.01.13-.01.19v12c0 .06 0 .13.01.19.04.75.18 1.49.48 2.19.66 1.59 1.9 2.63 3.55 3.07.56.15 1.14.22 1.72.23h12.29c.06 0 .13 0 .19-.01.75-.04 1.49-.18 2.19-.48 1.59-.66 2.63-1.9 3.07-3.55.15-.56.22-1.14.23-1.72V6.314c0-.063 0-.127-.006-.19zM15.998 6.37v8.76c0 1.22-.74 2.28-1.87 2.73a2.847 2.847 0 01-1.07.21c-1.55 0-2.81-1.26-2.81-2.81 0-1.55 1.26-2.81 2.81-2.81.34 0 .67.06.98.17V8.17l-5.25 1.51v6.29c0 1.22-.74 2.28-1.87 2.73-.34.13-.69.2-1.06.2-1.55 0-2.81-1.26-2.81-2.81s1.26-2.81 2.81-2.81c.34 0 .67.06.98.17V6.94c0-.5.33-.94.81-1.08l6.3-1.81c.63-.18 1.28.29 1.28.95v1.36z"/>
      </svg>
    ),
  },
  {
    label: 'Amazon Music',
    href: 'https://music.amazon.com/albums/B0GR2R3FKJ',
    color: '#00A8E1',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M13.958 10.09c0 1.232.029 2.256-.591 3.351-.502.891-1.301 1.438-2.186 1.438-1.214 0-1.922-.924-1.922-2.292 0-2.692 2.415-3.182 4.7-3.182v.685zm3.186 7.705c-.209.189-.512.201-.745.076-1.05-.873-1.234-1.276-1.814-2.106-1.733 1.767-2.96 2.294-5.207 2.294-2.66 0-4.729-1.641-4.729-4.925 0-2.565 1.391-4.309 3.37-5.164 1.715-.756 4.11-.891 5.942-1.095v-.41c0-.753.06-1.642-.383-2.294-.385-.579-1.124-.82-1.775-.82-1.205 0-2.277.618-2.54 1.897-.054.285-.261.567-.549.582l-3.061-.333c-.259-.056-.548-.266-.472-.66C5.515 2.337 8.418 1.5 11.01 1.5c1.329 0 3.063.354 4.111 1.36 1.329 1.244 1.202 2.904 1.202 4.71v4.27c0 1.284.531 1.847 1.031 2.54.174.246.213.539-.009.72l-2.201 1.695zm3.056 2.112c-3.601 2.662-8.823 4.076-13.319 4.076-6.3 0-11.977-2.329-16.261-6.207-.337-.305-.036-.721.37-.484 4.632 2.693 10.356 4.314 16.268 4.314 3.988 0 8.373-.827 12.403-2.541.609-.26 1.116.399.539.842zm1.532-1.747c-.461-.591-3.043-.279-4.201-.141-.353.043-.406-.264-.089-.486 2.057-1.446 5.433-1.028 5.826-.544.394.487-.103 3.862-2.034 5.476-.297.249-.58.116-.448-.212.435-1.083 1.407-3.513.946-4.093z"/>
      </svg>
    ),
  },
];

export default function Music() {
  return (
    <div>
      <div className="section-container">
        <h1 className="section-title">Music</h1>
        <div className="section-rule" />

        <div className="music-player-wrap">
          <iframe
            style={{ border: 0, width: '100%', height: '650px', display: 'block' }}
            src="https://bandcamp.com/EmbeddedPlayer/album=3277359218/size=large/bgcol=333333/linkcol=c94a1a/artwork=small/transparent=true/"
            seamless="seamless"
            allow="autoplay"
            title="Echo Hill on Bandcamp"
          >
            <a href="https://echohillband.bandcamp.com/album/echo-hill">Echo Hill by Echo Hill</a>
          </iframe>

          <div className="music-meta">
            <span>11 tracks &mdash; Released February 2026</span>
            <a
              href="https://echohillband.bandcamp.com/album/echo-hill"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open on Bandcamp ↗
            </a>
          </div>

          {/* Streaming links */}
          <div className="music-streaming">
            <p className="music-streaming-label">Also available on</p>
            <div className="music-streaming-icons">
              {STREAMING_LINKS.map(({ label, href, icon, color }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="music-streaming-btn"
                  aria-label={label}
                  title={label}
                  style={{ '--streaming-color': color }}
                >
                  {icon}
                  <span>{label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
